import { useRef as u, useState as i, useMemo as l, useEffect as m } from "react";
const h = ({ disabled: t } = { disabled: !1 }) => {
  const s = u(null), r = u(null), [f, o] = i(!1), n = l(() => t ? null : new ResizeObserver(() => {
    if (s.current && r.current) {
      const e = s.current.offsetWidth, c = r.current.offsetWidth;
      o(c <= e);
    }
  }), [t]);
  return m(() => {
    const e = r.current;
    return e && !t && n?.observe(e), () => {
      e && !t && n?.unobserve(e);
    };
  }, [t, n]), { isOverflowing: f, measureRef: s, targetElementRef: r };
};
export {
  h as useEllipsis
};
